import template from './rw-trend-indicator.html';

export default {
  template,
  bindings: {
    delta: '<',
    deltaAsPerc: '<',
    size: '=',
  },
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-trend-indicator/rw-trend-indicator-component.js